/**
 * Where the event form sits: on the calendar's purple modal (`dark`, its historical look, the
 * default), or on a white card of the assistant's chat (`light`). One form, two looks: the fields,
 * the rules and the save are the same; only these classes change.
 */
export type EventFormTone = "dark" | "light";

type ToneClasses = {
    /** Border of a field (input, picker, toolbar, editor). */
    border: string;
    field: string;
    placeholder: string;
    /** The icon that names a row. */
    icon: string;
    /** A toolbar button, hovered and active. */
    toolHover: string;
    toolActive: string;
    /** An attendee's chip, and its remove cross. */
    chip: string;
    chipRemove: string;
    checkbox: string;
};

export const eventFormTone: Record<EventFormTone, ToneClasses> = {
    dark: {
        border: "border-white/30",
        field: "rounded-md px-3 py-1.5",
        placeholder: "placeholder:text-white/70",
        icon: "",
        toolHover: "hover:bg-white/60",
        toolActive: "bg-white/30",
        chip: "bg-primary-dark text-white",
        chipRemove: "text-gray-500",
        checkbox:
            "bg-primary-dark data-[state=checked]:bg-primary-dark data-[state=checked]:text-white",
    },
    light: {
        border: "border-assistant-outline",
        field: "h-11 w-full rounded-2xl bg-white px-4 text-base text-primary-darkest",
        placeholder: "placeholder:text-assistant-muted",
        icon: "text-primary-darkest",
        toolHover: "hover:bg-primary-lightest",
        toolActive: "bg-primary-lightest",
        chip: "h-8 rounded-full bg-assistant-lavender px-3 text-[15px] font-semibold text-primary-darkest",
        chipRemove: "text-primary-darkest",
        checkbox:
            "size-5 rounded-md border-assistant-outline bg-white data-[state=checked]:border-primary-dark data-[state=checked]:bg-primary-dark data-[state=checked]:text-white",
    },
};
